import { sum } from '@jbrowse/core/util';
export function totalHeight(tracks, textHeight, trackLabels) {
    return sum(tracks.map(t => t.displays[0].height +
        (['none', 'left'].includes(trackLabels) ? 0 : textHeight)));
}
